module.exports = __webpack_public_path__ + "static/media/ckn_platillo_nuevo_error.dededa06.jpg";